import React from 'react';
import InlineEditableElement from 'Components/InlineEditableElement';
import {hoc} from 'Page/Sections/Jumbotron/Jumbotron';

class Jumbotron extends React.Component{

  render(){
    return (
      <div style={{paddingTop: '400px', height: '100%'}} className={this.props.loadAnimation}>
        <div className={'carousel-caption ' + this.props.actionAnimation || ''}>
          <InlineEditableElement size={this.props.size} fontFamilyChanged={this.props.fontFamilyChanged.bind(this)} style={{maxWidth: '100%'}} el="div" onChange={this.props.valueChanged.bind(this)} html={this.props.section.prop('content')} inlineEditingEnabled={this.props.inlineEditingEnabled} />
        </div>
        <div className="overlay"/>
      </div>
    );
  }

}

export default hoc(Jumbotron);
